if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (!this.dataset.url) return;

        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            this.observer.disconnect();
            this.loadRecommendations();
          },
          { rootMargin: '0px 0px 300px 0px' }
        );
        this.observer.observe(this);
      }

      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok) throw new Error(`Product recommendations request failed: ${response.status}`);

          const html = document.createElement('div');
          html.innerHTML = await response.text();
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim()) {
            this.innerHTML = recommendations.innerHTML;
          } else {
            this.remove();
          }
        } catch (error) {
          console.warn(error);
          this.remove();
        }
      }
    }
  );
}
